const theme = {
  BasicBox: {
    maxWidth: '300px',
    backgroundColor: 'black',
    color: 'white',
    fontSize: '20px',
    minHeight: '40px',
    padding: '5px 10px 5px 10px',
    boxSizing: 'border-box',
    borderRadius: '8px',
  },
};
export default theme;
